import { useEffect, useState } from 'react';

export default function useRerenderMinutely(active = true) {
  const [minuteToken, setMinuteToken] = useState(() =>
    Math.floor(Date.now() / 60000),
  );

  useEffect(() => {
    if (!active) {
      return;
    }

    const intervalId = setInterval(() => {
      const nextMinuteToken = Math.floor(Date.now() / 60000);

      setMinuteToken((currentMinuteToken) =>
        currentMinuteToken === nextMinuteToken
          ? currentMinuteToken
          : nextMinuteToken,
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, [active]);

  return minuteToken;
}
